import React from "react";
import SlideUpOnScroll from "./slide-up";
import {Failed, Success} from "./alert";
import GetInTouchInput from "./form_input";
import {ActionButton} from "./action-button";
import * as emailjs from "emailjs-com";

class GetInTouchForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            fullName: '',
            companyName: '',
            email: '',
            phoneNumber: '',
            services: '',
            succes: false,
            error: ''
        }
    }

    sendMessage = () => {
        let message = 'Name: ' + this.state.fullName;

        // Should fill in email
        if (!this.state.email) {
            this.setState({
                success: false,
                error: 'Please fill out the email field. We will contact you using this email.'
            });
            return;
        }

        if (!!this.state.companyName) {
            message += '\nCompany name: ' + this.state.companyName;
        }

        if (!!this.state.email) {
            message += '\nEmail: ' + this.state.email;
        }

        if (!!this.state.phoneNumber) {
            message += '\nPhone: ' + this.state.phoneNumber;
        }

        if (!!this.state.message) {
            message += '\nMessage: ' + this.state.message;
        }

        const templateParams = {
            to_email: this.state.email,
            from_email: this.state.email,
            title: 'Get In Touch Message',
            request: "User email: " + this.state.email + "\n\nMessage:\n" + message,
            subject: 'Get In Touch Message - BinaryFusion'
        };

        emailjs.send('service_4xmehup', 'template_oa9tg07', templateParams, 'SzxRcKLK0IJhNc3Wy')
            .then((response) => {
                this.setState({
                    fullName: '',
                    companyName: '',
                    email: '',
                    phoneNumber: '',
                    message: '',
                    success: true,
                });
            }, (err) => {
                console.log('FAILED...', err);
                this.setState({
                    success: false,
                    error: 'Failed to send request. Please try again later.'
                });
            });
    }

    render() {
        return (

            <div id='get-in-touch-form-outer' className='page-padding black-back'>
                <div className='space-100' />

                <div id="get-in-touch-form">
                    <div id="get-in-touch-left">
                        <div className='t2'>
                            <SlideUpOnScroll> Get In Touch </SlideUpOnScroll>
                        </div>

                        <div className='b1 flex-grow-1'>
                            <SlideUpOnScroll>Need a digital partner? Let’s connect.</SlideUpOnScroll>
                        </div>

                        <div id='separator' />

                        <div className='b1 mt-8'>+40741511416</div>
                        <div className='b1 mb-8'>contact@binaryfusion.ro</div>
                    </div>

                    <div id="get-in-touch-right">
                        <div className='git-row'>
                            <GetInTouchInput label="Full Name" value={this.state.fullName} onChange={e => this.setState({fullName: e.target.value})} />
                            <GetInTouchInput label="Company Name" value={this.state.companyName} onChange={e => this.setState({companyName: e.target.value})} />
                        </div>

                        <div className='git-row'>
                            <GetInTouchInput label="Email" value={this.state.email}  onChange={e => this.setState({email: e.target.value})} />
                            <GetInTouchInput label="Phone number" value={this.state.phoneNumber}  onChange={e => this.setState({phoneNumber: e.target.value})} />
                        </div>

                        <GetInTouchInput className='large-input multi' label="Message" value={this.state.message} onChange={e => this.setState({message: e.target.value})} />

                        <ActionButton className='primary-color white-color-txt align-self-end mt-2' onClick={() => this.sendMessage()} text="Send message" />


                        {this.state.success && <Success hide={() => this.setState({success: false})}/>}
                        {!!this.state.error && <Failed hide={() => this.setState({error: '', success: false})} content={this.state.error}/>}
                    </div>

                </div>

                <div className='space-80' />

            </div>
        );
    }
}

export default GetInTouchForm;